import communityWalkthrough from '../../modules/community/walkthrough/tn.json';

export const TN = {
  translation: {
    ...communityWalkthrough,
  },
};
